import './App.css';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './Router';
import { CasProvider } from './cas/CasProvider';

const casConfig = {
    casServer: process.env.REACT_APP_CAS!,
    service: process.env.REACT_APP_FRONT!

}

function App() {
    return (
    <CasProvider config={casConfig }>
        <BrowserRouter>
            <AppRouter />
        </BrowserRouter>
    </CasProvider>
  );
}

export default App;
